const BASE_DOCUMENT_LENGTH = 24

function normalizeDocumentDetails(raw, converted) {
  if (!Array.isArray(raw) || !converted) return converted

  // Generic exports contain only the 24-field Document base tuple.
  if (raw.length === BASE_DOCUMENT_LENGTH) {
    return {
      ...converted,
      joinableDivs: [],
      structuringelementSortOrder: [],
      structuringelement: {},
    }
  }

  // The dedicated exporter predates joinableDivs and appends sort order and
  // structuringelement directly after the base tuple (26 fields).
  if (raw.length === BASE_DOCUMENT_LENGTH + 2) {
    return {
      ...converted,
      joinableDivs: [],
      structuringelementSortOrder: raw[BASE_DOCUMENT_LENGTH],
      structuringelement: raw[BASE_DOCUMENT_LENGTH + 1],
    }
  }

  return {
    ...converted,
    structuringelementSortOrder: converted.structuringelementSortOrder || [],
    structuringelement: converted.structuringelement || {},
    joinableDivs: converted.joinableDivs || [],
  }
}

export { normalizeDocumentDetails }
